'use strict';

import app from '../../player/ngmodule';

app.component('rootContentCtrl', {
  template: require('./template.html').default
});